import React, { useEffect } from "react";
import { Mail, MapPin, Phone } from "lucide-react";
export default function GetInTouch() {
  useEffect(() => {
    if (!document.querySelector('script[src="https://assets.calendly.com/assets/external/widget.js"]')) {
      const script = document.createElement('script');
      script.src = 'https://assets.calendly.com/assets/external/widget.js';
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);
  return <section className="py-16 bg-background">
      <div className="container max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {}
          <div className="space-y-8">
            <div>
              <h2 className="text-3xl md:text-4xl font-semibold text-foreground mb-6 leading-snug">Get in Touch with IronPeak Men's Health</h2>
              <p className="text-base md:text-lg text-muted-dark leading-relaxed mb-6">Ready to take the first step towards optimizing your health and vitality? Whether you're exploring hormone optimization, metabolic health, or performance support — we're here to help you find answers</p>
              <p className="text-base md:text-lg text-muted-dark leading-relaxed mb-6">
                Schedule your comprehensive assessment today and discover 
                how we can help you regain your energy, confidence, and quality of life.
              </p>
              <div className="bg-secondary-light-bg p-4 rounded-md border border-secondary/20">
                <p className="text-base text-secondary font-medium">
                  <strong>Serving All of Texas:</strong> We provide comprehensive telemedicine consultations and treatment plans to patients throughout Texas.
                </p>
              </div>
            </div>

            {}
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="bg-primary/10 p-3 rounded-md">
                  <Phone className="h-6 w-6 text-primary" />
                </div>
                <div>
                  <h4 className="text-xl font-medium text-foreground mb-1">Phone</h4>
                  <p className="text-muted-dark">(469) 557-5547</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="bg-primary/10 p-3 rounded-md">
                  <Mail className="h-6 w-6 text-primary" />
                </div>
                <div>
                  <h4 className="text-xl font-medium text-foreground mb-1">Email</h4>
                  <p className="text-muted-dark">Mike@ironpeakmenshealth.com</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="bg-primary/10 p-3 rounded-md">
                  <MapPin className="h-6 w-6 text-primary" />
                </div>
                <div>
                  <h4 className="text-xl font-medium text-foreground mb-1">Location</h4>
                  <p className="text-muted-dark">Serving all of Texas via telemedicine</p>
                </div>
              </div>
            </div>
          </div>

          {}
          <div className="bg-white rounded-md border border-border shadow-soft p-8">
            <h3 className="text-2xl font-medium text-foreground mb-6">Schedule Your Consultation</h3>
            <p>Step 1: Book your free 30-minute consultation below<br />
                Step 2: Complete a brief medical intake form (sent via email)<br />
                Step 3: Dr. Flores reviews your history and meets with you via secure video<br />
            </p>
            <div className="calendly-inline-widget" data-url="https://calendly.com/mfloresdo/30min" style={{
            minWidth: '320px',
            height: '700px'
          }}></div>
          </div>
        </div>
      </div>
    </section>;
}